const DialogBox = ({
  modalTitle,
  modalFooter,
  modalContent,
  onClose,
  className = "",
  id,
}) => {
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className={`modal show d-block ${className}`}
        tabIndex="-1"
        id={id}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{modalTitle}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">{modalContent}</div>
            {modalFooter && (
              <div className="modal-footer">{modalFooter}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogBox;